import React from 'react';
import { Tag, Package, Award, Truck, Headphones } from 'lucide-react';
import '../../styles/homeFeatures.css';

const HomeFeatures = () => {
  const features = [
    {
      icon: Tag,
      title: 'Wholesale Pricing',
      description: 'Best prices for bulk purchases and dealers.',
    },
    {
      icon: Package,
      title: 'MOQ Based Orders',
      description: 'Flexible MOQ options for all products.',
    },
    {
      icon: Award,
      title: 'Premium Quality',
      description: 'Carefully selected premium quality products.',
    },
    {
      icon: Truck,
      title: 'Fast Processing',
      description: 'Quick order processing and timely delivery.',
    },
    {
      icon: Headphones,
      title: 'Dedicated Support',
      description: 'Our team is always here to help you.',
    },
  ];

  return (
    <div className="features-section-wrapper">
      <div className="features-container">
        {features.map((feature, index) => {
          const IconComponent = feature.icon;
          return (
            <div key={index} className="feature-card">
              <div className="feature-icon-wrapper">
                <IconComponent size={32} strokeWidth={1.5} />
              </div>
              <h3 className="feature-title">{feature.title}</h3>
              <p className="feature-description">{feature.description}</p>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default HomeFeatures;
